import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

@Pipe({
  name: 'yearOfAge'
})
export class DisplayYearOfAgePipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
  ) { }

  /**
   * example : {{ data.age | yearOfAge | async }}
   * return '25 Years'
   * return '25 ปี'
   */
  transform(value: any, args?: any): any {
    if (value) {
      return combineLatest(
        this.translate.get('calendar.year'),
      ).pipe(
        map(([_year]) => {
          return `${ value } ${ this.checkYearString(value, _year) }`;
        })
      );
    } else {
      return value;
    }
  }

  private checkYearString(value: any, yearStr): string {
    return this.translate.currentLang === 'en' && +value > 1 ? `${ yearStr }s` : yearStr;
  }
}
